import React from 'react';
import { useDispatch } from 'react-redux';

import { Nav } from './components/Nav';
import { NavButton } from './components/NavButton';
import { CHANGE_GLOSSARY_MODAL_VISIBILITY } from '../../../../store/js/modules/statspro/glossary/actions';

export const Header = () => {

    const dispatch = useDispatch();
    const showGlossaryModal = () => {

        return dispatch(
            CHANGE_GLOSSARY_MODAL_VISIBILITY.request( { isVisible: true } )
        );
    };
    
    return (
        <div className="statspro-header">
            <div className='statspro-header__wrapper wrapper mb-0'>
                <div className="statspro-header__search-wrapper"></div>
                <div className="statspro-header__nav-wrapper">
                    <Nav />
                </div>
                <div className="statspro-header__glossary-wrapper">
                    <NavButton
                        text="Glossary"
                        icon="info-circle"
                        onClick={ showGlossaryModal }
                    />
                </div>
            </div>
        </div>
    );
};
